import { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { Actions as ALLOWANCEACTIONS } from "../../store/actions/allowanceActions";
import { Actions as COMPANYACTIONS } from "../../store/actions/companyActions";
import { Actions as FSSREPORTACTIONS } from "../../store/actions/fssReportActions";
import { Actions as ACTIONS, Actions as PAYROLLACTIONS } from "../../store/actions/payrollActions";
import { Actions as PAYSLIPACTIONS } from "../../store/actions/payslipActions";
import { Actions as PERMISSIONACTIONS } from "../../store/actions/permissionActions";

import { ArrowLeftIcon, CheckIcon, ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import Spinner from "../common/Spinner";
import PayrollTable from "./PayrollTable";

const RunPayroll = ({
	payrollPage,
	employees,
	payPeriodDetails,
	departmentList,
	govtBonusGetList,
	payrollSaveAll,
	allowances,
	employeesNotReady,
	generating,
	generatingReports,
	totalEmployees,
	userEntersData,
}) => {
	useEffect(() => {
		if (payPeriodDetails && payPeriodDetails.id) {
			// payrollGetList(payPeriodDetails.id);
			// if condition so we don't repeat if we have it?
			if (
				payPeriodDetails.year &&
				(allowances?.governmentBonuses?.[0]?.periodEnd &&
					new Date(allowances.governmentBonuses[0].periodEnd).getFullYear()) != payPeriodDetails.year
			) {
				govtBonusGetList(payPeriodDetails.year);
			}
		}
	}, [payPeriodDetails && payPeriodDetails.id]);

	// useEffect(() => {
	// 	if (payrollPage == "done" && !generatingReports) {
	// 		setTimeout(() => {
	// 			console.log("payPeriodDetails?.complete", payPeriodDetails?.complete);
	// 			payrollGetList(payPeriodDetails.id);
	// 			setTimeout(() => {
	// 				payrollPageToggle("");
	// 			}, 3000);
	// 		}, 5000);
	// 	}
	// }, [payrollPage, generatingReports]);

	const percentReady = ((totalEmployees - employeesNotReady) * 100) / totalEmployees;

	if (!employees) {
		return <></>;
	}

	if (payrollPage == "done") {
		return (
			<div className="block text-center">
				<div id="all-done">
					<div className="block-content block-content-full">
						<span className="item item-circle bg-success-light">
							<CheckIcon style={{ height: "1.5em", marginTop: 9 }} />
						</span>
					</div>
					<div className="main">
						<h1 className="font-w700 text-center">All done!</h1>
						<p className="text-center">Congratulations on completing this payroll!</p>
					</div>
					{generatingReports && (
						<div className="block buttons center">
							<p className="text-center">We're generating your reports - with you shortly!</p>
							<p className="text-center">
								<Spinner
									style={{ width: "4rem", height: "4rem", verticalAlign: "middle", marginTop: 20 }}
									className="animate-spin -ml-1 mr-3 text-success"
								/>
							</p>
						</div>
					)}
					{/* {
            !generatingReports &&
            <div className="block buttons center">
              <div className="btn btn-default" onClick={() => openSendPayslipsModal(payPeriodDetails.id)}>Send email to employees</div>
              <div className="btn btn-default" onClick={() => downloadReport("payroll", payPeriodDetails.id)}>Download Payroll Report</div>
              <div className="btn btn-default" onClick={() => downloadAllPayslips(payPeriodDetails.id)}>Download Payslips</div>
              <div className="btn btn-default" type="button"
                onClick={() => {
                  const input = {
                    year: payPeriodDetails.year,
                    name: "fs5",
                    month: payPeriodDetails?.periodEnd && format(new Date(payPeriodDetails.periodEnd), "M")
                  }
                  downloadFSSReport(input)
                }}
              >Download {payPeriodDetails?.periodEnd && format(new Date(payPeriodDetails.periodEnd), "MMMM")} FS5</div>
            </div>
          } */}
				</div>
			</div>
		);
	}

	return (
		<>
			{departmentList?.map?.((department) => (
				<PayrollTable
					department={department}
					key={department.id}
				/>
			))}
			{departmentList && <PayrollTable noDepartment={true} />}

			{!departmentList && <PayrollTable all />}

			{userEntersData && (
				<div className="block-content pl-0 pr-0">
					<Link
						className={`btn btn-default pull-left`}
						to="../"
					>
						<ArrowLeftIcon className="h-7 w-7 align-sub mr-2" />
						Back To Payroll Checklist
					</Link>
				</div>
			)}
			{!userEntersData && (
				<>
					<div className="block-content pl-0 pr-0">
						{!!(employeesNotReady > 0) && (
							<div
								className="alert alert-success clearfix"
								style={{ color: "#232a32" }}
							>
								<ExclamationTriangleIcon
									style={{ height: "2.5em", verticalAlign: "middle", marginRight: 5 }}
								/>
								{employeesNotReady} employee{employeesNotReady > 0 && "s"} have not been saved. When all
								employees are saved, you have processed payroll for all your team. If specific employees
								did not work this period, you can choose to proceed regardless. However no payslip will
								be issued for the individual.
							</div>
						)}

						{generating && (
							<span
								className={`pull-left`}
								style={{
									height: "34px",
									minWidth: "200px",
									backgroundColor: "#00bb87",
									maxWidth: "200px",
									position: "relative",
								}}
							>
								<span
									style={{
										transition: "transform 0.2s ease-in-out",
										position: "absolute",
										backgroundColor: "#ea611c",
										width: `${percentReady}%`,
										height: "100%",
										left: "0",
									}}
								></span>
							</span>
						)}

						{!!(employeesNotReady > 0) && !generating && (
							<span
								className={`btn btn-success pull-left`}
								onClick={() => {
									payrollSaveAll();
								}}
							>
								Generate Remaining Payslips
							</span>
						)}

						<div className="text-right">
							<Link
								className={`btn btn-${
									!!employeesNotReady && employeesNotReady > 0 ? "warning" : "success"
								}`}
								to="../summary"
							>
								{!!employeesNotReady && employeesNotReady > 0 && (
									<ExclamationTriangleIcon
										style={{ height: "1.5em", float: "left", marginRight: 5 }}
									/>
								)}
								Continue to Summary
							</Link>
						</div>
					</div>
				</>
			)}
		</>
	);
};

const mapStateToProps = (state) => {
	const payPeriodDetails = state?.payroll?.payPeriodDetails;

	const employees = state?.payroll?.employees?.filter((e) =>
		e.salaries.find(
			(s) =>
				!s.paySchedule ||
				(payPeriodDetails &&
					(s.paySchedule == payPeriodDetails.payPeriods || s.paySchedule == payPeriodDetails.paySchedule)),
		),
	);

	const { departments, enableDepartments } = state?.company?.settings || {};
	const hasDepartments = enableDepartments === undefined ? !!departments?.length : enableDepartments;

	const { isAdmin } = state?.my?.profile || {};

	const managedByAdvisor = !!state?.company?.settings?.advisor;
	const clientEntersPayrollData = state?.company?.settings?.clientEntersPayrollData;
	const userIsAdvisor = state?.my?.profile?.advisorId === state.company?.settings?.advisor || isAdmin;
	const userIsClient = !managedByAdvisor || !userIsAdvisor;
	const userEntersData = userIsClient && clientEntersPayrollData;

	return {
		...state.payroll,
		payPeriodDetails,
		departmentList: hasDepartments && departments?.length > 1 && departments,
		allowances: state?.allowances,
		employees,
		org: state?.company?.settings?.org,
		employeesNotReady: employees?.filter(
			(employee) =>
				employee.employmentTypeName !== "External Contractor" &&
				!(
					employee.payslip?.ready &&
					(employee.payslip?.ready === true || employee.payslip?.ready?.toLowerCase?.() !== "no")
				),
		).length,
		totalEmployees: employees?.filter((employee) => employee.employmentTypeName !== "External Contractor").length,
		generating: state?.payroll?.generating?.all,
		permission: state?.permissions?.my?.payroll,
		jurisdiction: state?.company?.settings?.jurisdiction,
		paymentIntegration: state?.integration?.payment?.fyorin,
		showTILModal: state?.company?.settings?.showTILModal,
		userEntersData,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getMyPermissions: () => dispatch(PERMISSIONACTIONS.getMyPermissions()),
	allowanceGetList: () => dispatch(ALLOWANCEACTIONS.allowanceGetList()),
	govtBonusGetList: (year) => dispatch(ALLOWANCEACTIONS.govtBonusGetList(year)),
	payrollGetList: (payrunID) => dispatch(ACTIONS.payrollGetList(payrunID)),
	payrollPageToggle: (page) => dispatch(ACTIONS.payrollPageToggle(page)),
	payrollSaveAll: () => dispatch(ACTIONS.payrollSaveAll()),
	openSendPayslipsModal: (id) => dispatch(PAYSLIPACTIONS.sendPayslipsModal(true, id)),
	downloadAllPayslips: (id) => dispatch(ACTIONS.downloadAllPayslips(id)),
	downloadReport: (reportType, payPeriods, year, period) =>
		dispatch(ACTIONS.downloadReport(reportType, payPeriods, year, period)),
	setReopenPayrollModalOpen: () => dispatch(ACTIONS.setReopenPayrollModalOpen(true)),
	generateRTISubmissions: () => dispatch(ACTIONS.generateRTISubmissions()),
	downloadFSSReport: (data) => dispatch(FSSREPORTACTIONS.downloadFSSReport(data)),
	openBankTransferModal: (period) => {
		dispatch(COMPANYACTIONS.setBankTransferPeriod(period));
		dispatch(COMPANYACTIONS.setBankTransferModal(true));
	},
	openTestInLiveModal: () => {
		dispatch(PAYROLLACTIONS.setTestInLiveModal(true));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(RunPayroll);
